export default "__VITE_ASSET__D23NGUDA__"